import { Protest } from "api";
import { DateTime } from "luxon";
import { useMemo } from "react";

export const LIMIT_OF_DAYS_TO_DEFENSE = 1;

export const useIsLimitToProtestDefenseExcedeed = (
    protest?: Protest
): boolean => {
    return useMemo(() => {
        if (protest && protest.createdAt) {
            const date = DateTime.fromFormat(
                protest["createdAt"],
                "yyyy-MM-dd HH:mm:ss"
            ).toFormat("yyyy-MM-dd");

            const todayMinusLimitToAnswer = DateTime.local().minus({
                day: LIMIT_OF_DAYS_TO_DEFENSE,
            });

            return todayMinusLimitToAnswer.toFormat("yyyy-MM-dd") > date;
        }
        return false;
    }, [protest]);
};
